export const areas = [{
        name: "不限",
        value: ""
    },
    {
        name: "北京",
        value: "北京"
    },
    {
        name: "上海",
        value: "上海"
    },
    {
        name: "广州",
        value: "广州"
    },
    {
        name: "深圳",
        value: "深圳"
    },
    {
        name: "杭州",
        value: "杭州"
    },
    {
        name: "成都",
        value: "成都"
    },
    {
        name: "南京",
        value: "南京"
    },
    {
        name: "重庆",
        value: "重庆"
    },
    {
        name: "武汉",
        value: "武汉"
    }
]



// WEBPACK FOOTER //
// ./src/Data.js